/** @jsx isolateComponent */
import { Fragment } from 'react';
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Heading, HeadingLevel, Typography, } from '@zapier/design-system';
const headingCss = (size, titleTypography) => css `
  ${Typography[titleTypography
    ? titleTypography
    : size === 'small'
        ? 'pageHeader9'
        : 'pageHeader7']}
  color: ${Colors.neutral800};
`;
const childrenCss = () => css `
  ${Typography.paragraph3}
  color: ${Colors.neutral800};
`;
/**
 * Renders a title, with optional children under the next heading level.
 */
const Section = ({ children, title, titleTypography, size = 'large', }) => {
    return (isolateComponent(Fragment, null,
        isolateComponent(Heading, { css: headingCss(size, titleTypography) }, title),
        children && (isolateComponent(HeadingLevel, null,
            isolateComponent("div", { css: childrenCss() }, children)))));
};
export default Section;
